<ng-template #modal>
  <div class="mx-3 my-1">
    <div class="row mb-2">
      <bdg-label type="headline">
        Atualizamos nossos
        <br />
        termos de uso
      </bdg-label>
    </div>
    <div class="row">
      <bdg-label type="body-1">
        Ao utilizar os serviços, o usuário confirma que leu e compreendeu os Termos e Políticas aplicáveis ao serviço
        SIGRESIDÊNCIAS e concorda em ficar vinculado a eles.
      </bdg-label>
    </div>
    <div class="row mt-2">
      <bdg-label type="body-2">
        <a href="/termos" target="_blank" style="text-decoration: underline"> Visualizar termos de uso </a>
      </bdg-label>
    </div>
    <div class="row mt-4 justify-content-end">
      <button mat-button type="button" color="primary" (click)="onSubmit()">ESTOU CIENTE DOS TERMOS</button>
    </div>
  </div>
</ng-template>
